module.exports = __webpack_public_path__ + "a383fb04abc9b2e3fdb5cb8e76668f0b.png";